import { render, staticRenderFns } from "./FiringAlertsCard.vue?vue&type=template&id=6ff3fb12&scoped=true&"
import script from "./FiringAlertsCard.vue?vue&type=script&lang=js&"
export * from "./FiringAlertsCard.vue?vue&type=script&lang=js&"
import style0 from "./FiringAlertsCard.vue?vue&type=style&index=0&id=6ff3fb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3fb12",
  null
  
)

export default component.exports